import PropTypes from "prop-types";
// material
import { Box } from "@mui/material";
import logoImg from "src/assets/core_ni_logo.png";

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ sx }) {
  return <Box component="img" src={logoImg} sx={{ width: 150, ...sx }} />;
}
